import _ from 'lodash';
import {
  gridAppPlatformKeys,
  USER_ACTIONS,
  UserType,
} from '../containers/manageUsers/listUsers/listUserConstants';
import { SSPRolesEnum } from './Constants';
import { IUser } from '../models/user';
import { IUserRole } from '../models/IUserAccess';
import { isValidEmail } from './helper-utility';
import t from '../localization/en/translation.json';

export const updateAddNewUser = (
  users,
  selectedArray,
  rowId,
  isExternalUser = false,
  platformRoles
) => {
  return users.map((user) => {
    if (user.id === rowId) {
      const selectedUserType = selectedArray[0]?.userType?.toLowerCase(); 
      const isAiDisabledRoleAvailable = platformRoles.some((v) => v.key === SSPRolesEnum.PRJUSRAIDISABLED)
      const platformrole = platformRoles.find((v) => v.key === (selectedUserType === UserType.External && isAiDisabledRoleAvailable ? SSPRolesEnum.PRJUSRAIDISABLED : SSPRolesEnum.PRJUSR));
      return {
        ...user,
        ...selectedArray[0],
        isNewAddedRow: true,
        isAllowedDomain: isExternalUser,
        portalRoles: [{ id: platformrole.id }],
      };
    }
    return user;
  });
};

export const handleUserRoleChange = (
  projectUserAccess,
  appPlatformList,
  record,
  projectUsers,
  updatedUserRoles,
  userId,
  platform,
  roles
) => {
  const user = projectUsers.find((item) => item.id === userId);
  let temporaryProjectUserAccess = _.cloneDeep(updatedUserRoles);
  let userAccess = temporaryProjectUserAccess.find(
    (item) => item.userId === userId
  );
  const oldUserAccess = projectUserAccess.find(
    (item) => item.userId === userId
  );
  let isNewUser = false;
  if (!userAccess) {
    isNewUser = true;
    userAccess = {
      userId: user?.isNewAddedRow ? '' : userId,
      mail: user?.mail,
      givenName: user?.givenName,
      surname: user?.surname,
      language: user?.language,
      country: user?.country,
      appPlatforms: [],
    };
  }

  if (platform === gridAppPlatformKeys.SSP) {
    if (!userAccess.ssp) {
      userAccess.ssp = {
        roles: [...(oldUserAccess?.ssp?.roles || [])],
      };
    }
    if (!userAccess.ssp.oldRoles) {
      userAccess.ssp = {
        ...userAccess.ssp,
        oldRoles: userAccess.ssp?.roles.map((item) => item) || [],
      };
    }
    userAccess.ssp.newRoles =
      (Array.isArray(roles) && roles) || (roles && [roles]) || [];

    let changedRoles = _.difference(
      userAccess.ssp.newRoles,
      userAccess.ssp.oldRoles
    );

    if (changedRoles.indexOf('') > -1 && userAccess.ssp.oldRoles.length === 0) {
      changedRoles = [];
    }

    if (!changedRoles.length) {
      userAccess.ssp = undefined;
    }
  } else {
    const appPlatform = appPlatformList.find((item) => item.id === platform);
    if (appPlatform) {
      let appPlatformAccess = userAccess.appPlatforms.find(
        (item) => item.appPlatformId === platform
      );
      const appPlatformOldAccess = oldUserAccess?.appPlatforms?.find(
        (item) => item.appPlatformId === platform
      );
      let isNew = false;
      if (!appPlatformAccess) {
        isNew = true;
        const apps =
          record?.appDetails?.filter(
            (item) => item.appPlatformId === platform
          ) || [];
        appPlatformAccess = {
          appPlatformId: platform,
          appPlatformName: appPlatform.name,
          apps: apps.map((item) => item.appClassName) || [],
        };
      }

      if (
        !appPlatformAccess.oldRoles ||
        (Array.isArray(appPlatformAccess.oldRoles) &&
          appPlatformAccess.oldRoles.length === 0)
      ) {
        appPlatformAccess.oldRoles =
          appPlatformOldAccess?.roles?.map((item) => item) || [];
      }

      appPlatformAccess.newRoles =
        (Array.isArray(roles) && roles) || (roles && [roles]) || [];

      let changedRoles = _.difference(
        appPlatformAccess.newRoles,
        appPlatformAccess.oldRoles
      );

      let forceNoChange = false;
      if (
        changedRoles.indexOf('') > -1 &&
        appPlatformAccess.oldRoles.length === 0
      ) {
        changedRoles = [];
        forceNoChange = true;
      }

      if (!changedRoles.length && !forceNoChange) {
        changedRoles = _.difference(
          appPlatformAccess.oldRoles,
          appPlatformAccess.newRoles
        );
      }

      if (isNew && changedRoles.length) {
        userAccess.appPlatforms.push(appPlatformAccess);
      } else if (!changedRoles.length) {
        userAccess.appPlatforms = userAccess.appPlatforms.filter(
          (item) => item.appPlatformId !== platform
        );
      }
    }
  }

  userAccess.action = USER_ACTIONS.UPDATE;

  if (isNewUser) {
      if (user?.isNewAddedRow) {
        temporaryProjectUserAccess = temporaryProjectUserAccess?.map((v) => {
          if (v.mail === userAccess.mail) {
            return {
              ...v,
              ...(userAccess?.ssp ? { ssp: userAccess.ssp } : {}),
              ...(userAccess?.appPlatforms.length ? { appPlatforms: (v?.appPlatforms ? setPlatformRole(v.appPlatforms, userAccess.appPlatforms) : userAccess.appPlatforms) } : updateNewPlatformRole(v?.appPlatforms, platform)),
            };
          }
          return v;
        });
      } else temporaryProjectUserAccess.push(userAccess);
  } else {
    if (!userAccess.ssp && !userAccess.appPlatforms.length) {
      temporaryProjectUserAccess = temporaryProjectUserAccess.filter(
        (item) => item.userId !== userId
      );
    }
  }

  return temporaryProjectUserAccess;
};

export const updateNewPlatformRole = (currentRole, platformId) => {
  if(currentRole?.length) {
    return {appPlatforms: currentRole.filter(cr => cr.appPlatformId !== platformId)};
  }
  return {appPlatforms: []}
}

export const setPlatformRole = (currentRoles, newRoles) => {
  const filtercurrentRoles = currentRoles.filter(cr => !newRoles.some(nr => nr.appPlatformId === cr.appPlatformId));
  return [...filtercurrentRoles, ...newRoles];
}

export const createUserObject = (userData, platformRoles) => {
  let getRole = platformRoles.filter((v) => v.key === SSPRolesEnum.PRJUSR)[0];

  if (userData.userType?.toLowerCase() === UserType.External && platformRoles.find((v) => v.key === SSPRolesEnum.PRJUSRAIDISABLED)) {
    getRole = platformRoles.find((v) => v.key === SSPRolesEnum.PRJUSRAIDISABLED)
  }
  
  return {
    userId: '',
    mail: userData.mail,
    givenName: userData.givenName,
    surname: userData.surname,
    language: userData.language,
    country: userData.country,
    appPlatforms: [],
    ssp: {
      roles: [getRole ? getRole.id : ''],
      oldRoles: [],
      newRoles: [getRole ? getRole.id : ''],
    },
    action: USER_ACTIONS.UPDATE,
  };
};

export const handleRemoveUsers = (
  removeUsersData,
  updatedUserRoles,
  projectUserAccess
) => {
  const updatedUsers = _.cloneDeep(
    updatedUserRoles.filter((user: IUser) => user?.userId !== '')
  );
  const existingUsers = removeUsersData.filter(
    (user: IUser) => !user.userDetails?.isNewAddedRow
  );
  existingUsers.forEach((user: IUser) => {
    let userAccess: IUserRole = updatedUsers.find(
      (item) => item.userId === user.id
    );
    const oldUserAccess = projectUserAccess.find(
      (item) => item.userId === user.id
    );
    let usedOld = false;
    if (!userAccess) {
      usedOld = true;
      userAccess = _.cloneDeep(oldUserAccess || {});
    }
    userAccess.action = USER_ACTIONS.DELETE;

    if (usedOld) {
      updatedUsers.push(userAccess);
    }
  });

  return updatedUsers;
};

export const getAtleastOneAdminUser = (allUser, updatedUsers, appRoles) => {
  const getadminIds = appRoles.ssp.roles.filter(
    (role) => role.key === SSPRolesEnum.PRJADMIN
  )[0];
  const notSelectedUsers: any = [];
  allUser?.forEach((v) => {
    if (!updatedUsers.some((n) => n.id === v.userId)) notSelectedUsers.push(v);
  });
  const isAdminAvailable = notSelectedUsers.some(
    (v) => v.ssp.roles.indexOf(getadminIds.id) > -1
  );
  if (notSelectedUsers.length === 0 || !isAdminAvailable) return true;
  return false;
};

const isAllNewUsers = (usersList) => {
  return usersList.every((user) => user.userDetails?.isNewAddedRow || user.userDetails?.userId === '');
};

export const getAtleastOneOldUser = (usersList, allUsers, newAddedUser) => {
  const isAllNewUser = isAllNewUsers(usersList);

  if (isAllNewUser) {
    const updatedNewUser = newAddedUser.filter(
      (v) => !usersList.some((n) => n.userEmail === v.mail)
    );
    const updatedusers = allUsers.filter((user) => !usersList.some((n) => n.id === user.id));
    return { isAllNewUser, updatedusers, updatedNewUser };
  }
  return { isAllNewUser, updatedusers: [], updatedNewUser: [] };
};

export const getNewUserLimit = (usersList) => {
  const newUserLimit = 50;
  const currentNewUsers = usersList?.filter(
    (user) => user.isNewAddedRow
  ).length;
  return !(currentNewUsers >= newUserLimit);
};

export const handleEmailValidation = (email) => {
  if (!isValidEmail(email)) {
    return { inValid: true, message: t.manage_user_invalid_email };
  }
  return { inValid: false, message: '' };
};

export const createDomainUser = (
  userData,
  name,
  value,
  platformRoles,
  currentDomainUsers
) => {
  const getRole = platformRoles.filter((v) => v.key === SSPRolesEnum.PRJUSR)[0];
  const newUser = {
    userId: '',
    mail: userData.mail,
    givenName: name === 'userFname' ? value : userData.givenName,
    surname: name === 'userLname' ? value : userData.surname,
    language: name === 'userLanguage' ? value?.label : userData.language ?? 'English',
    country: name === 'userCountry' ? value?.label : userData.country,
    appPlatforms: [],
    ssp: {
      roles: [getRole ? getRole.id : ''],
      oldRoles: [],
      newRoles: [getRole ? getRole.id : ''],
    },
    action: USER_ACTIONS.UPDATE,
  };
  if (currentDomainUsers?.length) {
    const isExistingUser = currentDomainUsers.some(
      (v) => v.mail === userData.mail
    );
    if (isExistingUser) {
      return currentDomainUsers.map((v) => {
        if (v.mail === userData.mail) {
          return {
            ...v,
            givenName: name === 'userFname' ? value : v.givenName,
            surname: name === 'userLname' ? value : v.surname,
            language: name === 'userLanguage' ? value?.label : v.language,
            country: name === 'userCountry' ? value?.label : v.country,
          };
        }
        return v;
      });
    } else {
      return [...currentDomainUsers, newUser];
    }
  } else return [newUser];
};

export const setCountryLanguage = (
  currentUser,
  columnDef,
  country,
  language
) => {
  if (columnDef === 'userLanguage') {
    const getLang = language.find((v) => v.name === currentUser?.language);
    if (getLang)
      return {
        value: getLang.key,
        label: getLang.name,
      };
    else
      return {
        value: 'en',
        label: 'English',
      };
  } else {
    const getCountry = country.find((v) => v.name === currentUser?.country);
    if (getCountry)
      return {
        value: getCountry.key,
        label: getCountry.name,
      };
    else return { value: '', label: '' };
  }
};

export const updateDomainDetails = (finalRoles, domainUsers) => {
  const updatedDomainUsers = finalRoles.map((user) => {
    const isDomain = domainUsers.find((role) => role.mail === user.mail);
    if (isDomain) {
      return {
        ...user,
        givenName: isDomain?.givenName ?? '',
        surname: isDomain?.surname ?? '',
        language: isDomain?.language ?? '',
        country: isDomain?.country ?? '',
      };
    } else {
      return user;
    }
  });
  return updatedDomainUsers;
};

export const isValidUserRow = (user, projectUsers) => {
  let isValid = false;
  projectUsers.forEach((n) => {
    if (n?.isAllowedDomain) {
      const savingUser = user.find((u) => u.mail === n.mail);
      isValid =
        savingUser &&
        (!savingUser?.mail ||
          !savingUser?.givenName ||
          !savingUser?.surname ||
          !savingUser?.language ||
          !savingUser?.country);
    }
  });
  return isValid;
};

export const checkIfToolTipRequired = (text, width) => {
  const ctx = document.createElement('canvas').getContext('2d');
  const maxWidth = width * 0.8;
  if (ctx) {
    ctx.font = 'normal 15px EYInterstate-Regular';
    const textMeasurment = ctx.measureText(text);
    return textMeasurment.width >= maxWidth;
  } else if (text.length <= 28) {
    return false;
  }
};

export const filterUserList = (allUsers, maxRecordsPerPage, currentPage, userInputSearch, pagination, failedDomainUsers) => {
  if (allUsers && allUsers.length > 0) {
    const startIndex = (currentPage - 1) * maxRecordsPerPage;
    const endIndex = startIndex + maxRecordsPerPage;
    let filteredUsers = allUsers;
    if(failedDomainUsers?.length){
      const { newUsers, existingUsers } = splitNewAndExistingUsers(allUsers);
      filteredUsers = [...newUsers, ...failedDomainUsers, ...existingUsers];
    }
    if (userInputSearch?.trim()?.length > 2) {
      filteredUsers = allUsers.filter(
        (user) => {
          const userName = (user?.givenName ? user.givenName : '') + ' ' + (user?.surname ? user.surname : '');
          const search = userInputSearch.trim().toLowerCase();
          if (
            (user?.mail && user.mail.toLowerCase().includes(search)) ||
            (userName?.length && userName.toLowerCase().includes(search))
          ) {
            return user;
          }
          return false;
        }
      );
    }
    const projectUsersList = filteredUsers.slice(startIndex, endIndex);
    return {projectUsersList, gridPagination: {...pagination, pageSize: filteredUsers?.length, totalRecords: filteredUsers?.length}};
  }
  return {projectUsersList: [], gridPagination: {...pagination, pageSize: allUsers?.length, totalRecords: allUsers?.length}};
};

export const isAtleastOneAdminUser = (allUser, updatedUsers, appRoles) => {
  const getadminIds = appRoles.ssp.roles.filter(
    (role) => role.key === SSPRolesEnum.PRJADMIN
  )[0];
  const notUpdatedUsers: any = [];
  let isUpdatedAdmin: boolean = false;

  allUser?.forEach((v) => {
    const updatedUser = updatedUsers.find((n) => n?.userDetails ? n?.userDetails.mail : n.mail === v.mail);
    if (updatedUser && updatedUser?.ssp) {
      isUpdatedAdmin = updatedUser?.ssp?.newRoles?.indexOf(getadminIds.id) > -1 || isUpdatedAdmin;
    }else{
      notUpdatedUsers.push(v);
    }
  });

  const isAdminAvailable = notUpdatedUsers.some(
    (v) => v.ssp.roles.indexOf(getadminIds.id) > -1
  );
  if(isUpdatedAdmin) return false;
  if (!isAdminAvailable) return true;
  return false;
};

export const getSuccessMessage = (
  isDeleteUserClicked,
  totalRecords,
  failedRecords
) => {
  if (isDeleteUserClicked) {
    return {
      message: t.manage_user_successful_removal_toaster_msg,
      type: 'success',
    };
  } else if (failedRecords > 0 && totalRecords > 0) {
    return {
      message: t.manage_user_successful_msg3.replace(
        '{|fail|}',
        failedRecords.toString()
      ),
      type: 'warning',
    };
  }
  return {
      message: t.manage_user_successful_msg2,
      type: 'success',
    };
};

export const splitNewAndExistingUsers = (allUsers) => {
  const newUsers = allUsers.filter(user => user?.isNewAddedRow);
  const existingUsers = allUsers.filter(user => !user?.isNewAddedRow);
  return { newUsers, existingUsers };
};

export const failedDomainUsersAsNew = (allFailedUsers, updatedUsers) => {
  const finalData = updatedUsers.filter(v => allFailedUsers.some(n => n.email === v.mail));
  return finalData.map(user => {
    return {
      ...user,
      ...(user.userId === '' ? { isNewAddedRow: true } : {})
    }
  });
};

export const domainDeleteValidation = (selectedRows, projectUsersList) => {
  const selectedDomain = selectedRows[0];
    const domainName = selectedDomain?.domainExpression?.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');
    const isDomainUsed = projectUsersList.filter(user => user?.isNewAddedRow && user.mail?.toLowerCase().endsWith(`${domainName.toLowerCase()}`));
    if(isDomainUsed?.length) {
      return { count: isDomainUsed.length, domainName: selectedDomain.domainExpression };
    }
  return { count: 0, domainName: '' };
};
